import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3338a5f6")
const _hoisted_1 = { class: "w-full p-3 border-b bg-gray-50 rounded-t text-sm dark:border-custom-black-150 dark:bg-custom-black-150 dark:bg-opacity-50" }
const _hoisted_2 = { class: "p-3 border-gray-100 border-b relative dark:border-custom-black-150" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "mr-3" }
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "text-gray-500 dark:text-gray-1150 text-sm" }
const _hoisted_7 = { class: "arrow-down" }
const _hoisted_8 = { class: "p-3" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "mr-3" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = { class: "text-gray-500 dark:text-gray-1150 text-sm" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "p-3 flex w-full items-center justify-between border-b dark:border-custom-black-150" }
const _hoisted_15 = { class: "flex divide-x dark:divide-gray-500 text-xs uppercase" }
const _hoisted_16 = { class: "p-3 text-sm" }
const _hoisted_17 = { class: "summary-item-row" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "summary-item-row"
}
const _hoisted_20 = { class: "text-green-400" }
const _hoisted_21 = { class: "summary-item-row" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "w-full p-3 rounded-b-lg bg-white text-sm dark:bg-custom-black-150 dark:bg-opacity-50" }
const _hoisted_24 = { class: "summary-item-row font-medium" }
const _hoisted_25 = { class: "w-64" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "summary-item-row text-gray-500 dark:text-gray-1150" }
const _hoisted_28 = { class: "w-64" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  key: 1,
  class: "flex my-5 justify-center items-center"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("1")
const _hoisted_32 = { class: "mb-2 font-semibold" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "step-seperator" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("1")
const _hoisted_35 = { class: "mb-2 font-semibold" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "step-seperator" }, null, -1)
const _hoisted_37 = { class: "mb-2 font-semibold" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "step-seperator" }, null, -1)
const _hoisted_39 = { class: "mb-2 font-semibold" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_ArrowDownIcon = _resolveComponent("ArrowDownIcon")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_TradeRoute = _resolveComponent("TradeRoute")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: "",
    onClose: _ctx.onClose,
    title: _ctx.labels.modalTitle,
    changeType: "trade"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_BalCard, {
          noPad: "",
          class: "relative mb-6 overflow-auto",
          borderColor: "custom-black-150",
          changeType: "trade"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('effectivePrice')) + " " + _toDisplayString(_ctx.trading.exactIn.value
                  ? _ctx.trading.effectivePriceMessage.value.tokenIn
                  : _ctx.trading.effectivePriceMessage.value.tokenOut), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_BalAsset, {
                      address: _ctx.trading.tokenIn.value.address,
                      size: 36
                    }, null, 8, ["address"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.fNum2(_ctx.trading.tokenInAmountInput.value, _ctx.FNumFormats.token)) + " " + _toDisplayString(_ctx.trading.tokenIn.value.symbol), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.tokenInFiatValue), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ArrowDownIcon)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_BalAsset, {
                      address: _ctx.trading.tokenOut.value.address,
                      size: 36
                    }, null, 8, ["address"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.fNum2(_ctx.trading.tokenOutAmountInput.value, _ctx.FNumFormats.token)) + " " + _toDisplayString(_ctx.trading.tokenOut.value.symbol), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.tokenOutFiatValue) + " ", 1),
                      (
                      _ctx.trading.isBalancerTrade.value ||
                        _ctx.trading.isWrapUnwrapTrade.value
                    )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " / " + _toDisplayString(_ctx.$t('priceImpact')) + ": " + _toDisplayString(_ctx.fNum2(_ctx.trading.sor.priceImpact.value, _ctx.FNumFormats.percent)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_BalCard, {
          noPad: "",
          shadow: "none",
          class: "mb-3",
          borderColor: "custom-black-150",
          changeType: "trade"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, _toDisplayString(_ctx.labels.tradeSummary.title), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                  'pr-2 cursor-pointer font-medium',
                  { 'text-blue-950': !_ctx.showSummaryInFiat }
                ]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSummaryInFiat = false))
                }, _toDisplayString(_ctx.$t('tokens')), 3),
                _createElementVNode("div", {
                  class: _normalizeClass([
                  'pl-2 cursor-pointer font-medium uppercase',
                  { 'text-blue-950': _ctx.showSummaryInFiat }
                ]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSummaryInFiat = true))
                }, _toDisplayString(_ctx.FiatCurrency.usd), 3)
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.labels.tradeSummary.totalAfterFees), 1),
                _createElementVNode("div", {
                  innerHTML: _ctx.summary.totalWithoutSlippage
                }, null, 8, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.labels.tradeSummary.totalWithSlippage), 1),
                _createElementVNode("div", {
                  innerHTML: 
                  _ctx.trading.isWrapUnwrapTrade.value
                    ? ''
                    : _ctx.summary.totalWithSlippage
                
                }, null, 8, _hoisted_29)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, _toDisplayString(_ctx.labels.tradeSummary.totalBeforeFees), 1),
                _createElementVNode("div", {
                  innerHTML: _ctx.summary.amountBeforeFees
                }, null, 8, _hoisted_18)
              ]),
              (_ctx.trading.isGnosisTrade.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('tradeSummary.gasCosts')), 1),
                    _createElementVNode("div", _hoisted_20, "-" + _toDisplayString(_ctx.zeroFee), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", null, _toDisplayString(_ctx.labels.tradeSummary.tradeFees), 1),
                _createElementVNode("div", {
                  innerHTML: 
                _ctx.trading.isWrapUnwrapTrade.value
                  ? _ctx.zeroFee
                  : _ctx.trading.isGnosisTrade.value
                  ? _ctx.trading.exactIn.value
                    ? `-${_ctx.summary.tradeFees}`
                    : `+${_ctx.summary.tradeFees}`
                  : _ctx.summary.tradeFees
              
                }, null, 8, _hoisted_22)
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.showPriceUpdateError)
          ? (_openBlock(), _createBlock(_component_BalAlert, {
              key: 0,
              class: "p-3 mb-4",
              type: "error",
              size: "md",
              title: _ctx.$t('priceUpdatedAlert.title'),
              description: 
          _ctx.$t('priceUpdatedAlert.description', [
            _ctx.fNum2(_ctx.PRICE_UPDATE_THRESHOLD, _ctx.FNumFormats.percent)
          ])
        ,
              "action-label": _ctx.$t('priceUpdatedAlert.actionLabel'),
              block: "",
              onActionClick: _ctx.cofirmPriceUpdate
            }, null, 8, ["title", "description", "action-label", "onActionClick"]))
          : _createCommentVNode("", true),
        (_ctx.totalRequiredTransactions > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              (_ctx.showGnosisRelayerApprovalStep)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_BalTooltip, {
                      disabled: !_ctx.requiresGnosisRelayerApproval,
                      width: "64"
                    }, {
                      activator: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                  'step',
                  {
                    'step-active':
                      _ctx.activeTransactionType === 'gnosisRelayerApproval',
                    'step-approved': !_ctx.requiresGnosisRelayerApproval
                  }
                ])
                        }, [
                          (!_ctx.requiresGnosisRelayerApproval)
                            ? (_openBlock(), _createBlock(_component_BalIcon, {
                                key: 0,
                                name: "check",
                                class: "text-green-500"
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_31
                              ], 64))
                        ], 2)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t(
                      'tradeSummary.transactionTypesTooltips.gnosisRelayerApproval.title'
                    )), 1)
                          ]),
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t(
                    'tradeSummary.transactionTypesTooltips.gnosisRelayerApproval.content'
                  )), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _hoisted_33
                  ], 64))
                : (_ctx.showLidoRelayerApprovalStep)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_BalTooltip, {
                        disabled: !_ctx.requiresLidoRelayerApproval,
                        width: "64"
                      }, {
                        activator: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'step',
                  {
                    'step-active':
                      _ctx.activeTransactionType === 'lidoRelayerApproval',
                    'step-approved': !_ctx.requiresLidoRelayerApproval
                  }
                ])
                          }, [
                            (!_ctx.requiresLidoRelayerApproval)
                              ? (_openBlock(), _createBlock(_component_BalIcon, {
                                  key: 0,
                                  name: "check",
                                  class: "text-green-500"
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_34
                                ], 64))
                          ], 2)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.$t(
                      'tradeSummary.transactionTypesTooltips.lidoRelayerApproval.title'
                    )), 1)
                            ]),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t(
                    'tradeSummary.transactionTypesTooltips.lidoRelayerApproval.content'
                  )), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _hoisted_36
                    ], 64))
                  : _createCommentVNode("", true),
              (_ctx.showTokenApprovalStep)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.showTokenApprovalStep)
                      ? (_openBlock(), _createBlock(_component_BalTooltip, {
                          key: 0,
                          disabled: !_ctx.requiresTokenApproval,
                          width: "64"
                        }, {
                          activator: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass([
                  'step',
                  {
                    'step-active': _ctx.activeTransactionType === 'tokenApproval',
                    'step-approved': !_ctx.requiresTokenApproval
                  }
                ])
                            }, [
                              (!_ctx.requiresTokenApproval)
                                ? (_openBlock(), _createBlock(_component_BalIcon, {
                                    key: 0,
                                    name: "check",
                                    class: "text-green-500"
                                  }))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.showGnosisRelayerApprovalStep || _ctx.showLidoRelayerApprovalStep
                    ? 2
                    : 1), 1)
                                  ], 64))
                            ], 2)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t(
                    'tradeSummary.transactionTypesTooltips.tokenApproval.title',
                    [_ctx.trading.tokenIn.value.symbol]
                  )), 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.$t(
                    'tradeSummary.transactionTypesTooltips.tokenApproval.content'
                  )), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    _hoisted_38
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_BalTooltip, { width: "64" }, {
                activator: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                'step',
                {
                  'step-active': _ctx.activeTransactionType === 'trade'
                }
              ])
                  }, _toDisplayString(_ctx.totalRequiredTransactions), 3)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.trading.isGnosisTrade.value
                  ? _ctx.$t('tradeSummary.transactionTypesTooltips.sign.title')
                  : _ctx.$t('tradeSummary.transactionTypesTooltips.trade.title')), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.trading.isGnosisTrade.value
                  ? _ctx.$t('tradeSummary.transactionTypesTooltips.sign.content')
                  : _ctx.$t('tradeSummary.transactionTypesTooltips.trade.content')), 1)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.requiresGnosisRelayerApproval)
          ? (_openBlock(), _createBlock(_component_BalBtn, {
              key: 2,
              block: "",
              onClick: _withModifiers(_ctx.gnosisRelayerApproval.approve, ["prevent"]),
              loading: 
          _ctx.gnosisRelayerApproval.init.value ||
            _ctx.gnosisRelayerApproval.approving.value
        ,
              "loading-label": `${_ctx.$t('approvingGnosisRelayer')}...`,
              changeType: "trade",
              color: "custom-blue-50"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('approveGnosisRelayer')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading", "loading-label"]))
          : (_ctx.requiresLidoRelayerApproval)
            ? (_openBlock(), _createBlock(_component_BalBtn, {
                key: 3,
                block: "",
                onClick: _withModifiers(_ctx.lidoRelayerApproval.approve, ["prevent"]),
                loading: 
          _ctx.lidoRelayerApproval.init.value || _ctx.lidoRelayerApproval.approving.value
        ,
                "loading-label": `${_ctx.$t('approvingLidoRelayer')}...`,
                changeType: "trade",
                color: "custom-blue-50"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('approveLidoRelayer')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading", "loading-label"]))
            : (_ctx.requiresTokenApproval)
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 4,
                  loading: _ctx.tokenApproval.approving.value,
                  "loading-label": `${_ctx.$t('approving')} ${_ctx.trading.tokenIn.value.symbol}...`,
                  block: "",
                  onClick: _withModifiers(_ctx.approveToken, ["prevent"]),
                  changeType: "trade",
                  color: "custom-blue-50"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`${_ctx.$t('approve')} ${_ctx.trading.tokenIn.value.symbol}`), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "loading-label", "onClick"]))
              : (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 5,
                  block: "",
                  onClick: _withModifiers(_ctx.trade, ["prevent"]),
                  loading: _ctx.trading.isConfirming.value,
                  "loading-label": _ctx.$t('confirming'),
                  disabled: _ctx.tradeDisabled,
                  class: "relative",
                  changeType: "trade",
                  color: "custom-blue-50"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.labels.confirmTrade), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "loading-label", "disabled"])),
        (_ctx.trading.submissionError.value != null)
          ? (_openBlock(), _createBlock(_component_BalAlert, {
              key: 6,
              class: "p-3 mt-4",
              type: "error",
              size: "md",
              title: _ctx.$t('tradeSubmissionError.title'),
              description: _ctx.trading.submissionError.value,
              block: "",
              "action-label": _ctx.$t('tradeSubmissionError.actionLabel'),
              onActionClick: _ctx.trading.resetSubmissionError
            }, null, 8, ["title", "description", "action-label", "onActionClick"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showTradeRoute)
        ? (_openBlock(), _createBlock(_component_TradeRoute, {
            key: 0,
            "address-in": _ctx.trading.tokenIn.value.address,
            "amount-in": _ctx.trading.tokenInAmountInput.value,
            "address-out": _ctx.trading.tokenOut.value.address,
            "amount-out": _ctx.trading.tokenOutAmountInput.value,
            pools: _ctx.trading.sor.pools.value,
            "sor-return": _ctx.trading.sor.sorReturn.value,
            changeType: "trade",
            class: "mt-3"
          }, null, 8, ["address-in", "amount-in", "address-out", "amount-out", "pools", "sor-return"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClose", "title"]))
}